import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const StockLevelGauge = ({ data, detailed = false }) => {
  const processData = () => {
    const lowStock = data.filter(item => item.current_quantity <= item.min_quantity).length;
    const adequateStock = data.filter(item => 
      item.current_quantity > item.min_quantity && 
      item.current_quantity <= item.min_quantity * 2
    ).length;
    const highStock = data.filter(item => item.current_quantity > item.min_quantity * 2).length;

    return {
      labels: ['Low Stock', 'Adequate Stock', 'High Stock'],
      datasets: [{
        data: [lowStock, adequateStock, highStock],
        backgroundColor: [
          'rgba(239, 68, 68, 0.7)',
          'rgba(234, 179, 8, 0.7)',
          'rgba(16, 185, 129, 0.7)'
        ],
        borderColor: [
          'rgba(239, 68, 68, 1)',
          'rgba(234, 179, 8, 1)',
          'rgba(16, 185, 129, 1)'
        ],
        borderWidth: 1,
      }]
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const value = context.raw;
            const percentage = Math.round((value / total) * 100);
            return `${context.label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
    cutout: detailed ? '50%' : '70%'
  };

  return <Doughnut data={processData()} options={options} />;
};

export default StockLevelGauge;